import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import GenerateCustomGuidEditing from "./generatecustomguidediting";

export default class GenerateCustomGuid extends Plugin {
    static get pluginName() {
        return "GenerateCustomGuid";
    }

    static get requires() {
        return [GenerateCustomGuidEditing];
    }
}
